<template>
  <div class="modal-container">
    <div class=" add-box clearfix">
      <vxe-table
          border
          keep-source
          show-overflow
          class="table-style"
          :auto-resize="true"
          ref="xTable"
          max-height="500"
          :show-footer="true"
          :edit-rules="validRules"
          :data="tableData"
          :edit-config="{ trigger: 'click', mode: 'cell' }"
      >
        <vxe-table-column width="40" align="center">
          <template v-slot:header>
            <Button class="add-btn" icon="md-add" @click="insertEvent()"></Button>
          </template>
          <template v-slot="{ row, $rowIndex }">
            <Button class="del-btn" icon="md-remove" @click="removeEvent(row, $rowIndex)"></Button>
          </template>
        </vxe-table-column>
        <vxe-table-column field="no" title="序号" width="60"></vxe-table-column>
        <vxe-table-column title="关联主订单" width="200" field="relOrdersNum">
          <template v-slot="{ row }">
            <a @click="openOrderModal(row)">{{
                row.relOrdersNum === null || row.relOrdersNum === "" ? "选择关联主订单" : row.relOrdersNum
              }}
              <Icon type="md-close" @click.stop="clearRelOrdersNum(row)" v-show="row.relOrdersNum"/>
            </a>
          </template>
        </vxe-table-column>
        <vxe-table-column title="所属公司" width="200" field="compName">
          <template v-slot:header="{ column }">
            <span class="column-title"><i style="color: #f00"> * </i>{{ column.title }}</span>
          </template>
          <template v-slot="{ row }">
            <platform-corp :row="row" :field="'compName'" :isEdit="!row.choose"
                           :placeholder="'请选择所属公司'"></platform-corp>
          </template>
        </vxe-table-column>
        <vxe-table-column title="订单类型" field="ordersType" width="100">
          <template v-slot:header="{ column }">
            <span class="column-title"><i style="color: #f00"> * </i>{{ column.title }}</span>
          </template>
          <template v-slot="{ row }">
            <vxe-select v-model="row.ordersType" placeholder="请选择" :options="orderType" transfer></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column title="订单标题" field="ordersTitleAttached" width="200">
          <template v-slot="{ row }">
            <vxe-input v-model="row.ordersTitleAttached" placeholder="选填" clearable></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column title="销售方" width="200" field="sellerName">
          <template v-slot:header="{ column }">
            <span class="column-title"><i style="color: #f00"> * </i>{{ column.title }}</span>
          </template>
          <template v-slot="{ row }">
            <a target="_black" @click="openChooseAccount(row)">
              {{ row.sellerName ? row.sellerName : "请选择销售方" }}
            </a>
          </template>
        </vxe-table-column>
        <vxe-table-column title="金额" field="settlementAmount" width="120">
          <template v-slot:header="{ column }">
            <span class="column-title"><i style="color: #f00"> * </i>{{ column.title }}</span>
          </template>
          <template v-slot="{ row }">
            <vxe-input v-model="row.settlementAmount" type="number" placeholder="必填" clearable></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column title="业务员" width="200" field="saleMan">
          <template v-slot:header="{ column }">
            <span class="column-title"><i style="color: #f00"> * </i>{{ column.title }}</span>
          </template>
          <template v-slot="{ row }">
            <sales-man :row="row" :field="'saleMan'" :placeholder="'请选择业务员'" @setSaleMan="file => setSaleMan(file,row)"
                       :isEdit="!row.choose" @focus="clearValidate" @blur="clearValidate"
            ></sales-man>
          </template>
        </vxe-table-column>
        <!--        <vxe-table-column title="客户经理" field="clientManage" width="200">-->
        <!--          <template v-slot="{ row }">-->
        <!--            <vxe-input v-model="row.clientManage" placeholder="自动带入" readonly></vxe-input>-->
        <!--          </template>-->
        <!--        </vxe-table-column>-->
        <vxe-table-column title="关联合同" field="relContractNum" width="200">
          <template v-slot="{ row }">
            <div class="input-border">
              <a @click="openContract(row)">{{
                  row.relContractNum === null || row.relContractNum === '' ? '请选择关联合同' : row.relContractNum
                }}
                <Icon type="md-close" @click.stop="clearContractNum(row)" v-show="row.relContractNum"/>
              </a>
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div class="modal-footer add-btn-box">
      <Button type="primary" @click="importEvent">上传导入文件</Button>
      <Button type="primary" @click="commit">提 交</Button>
    </div>
    <vxe-modal v-model="isShowChooseAccount" width="800" height="600" resize remember title="客户名称">
      <account @choose="chooseAccountEvent" ref="chooseAccount"></account>
    </vxe-modal>
    <vxe-modal v-model="isShowContract" title="关联合同" width="1400" height="600" resize>
      <choose-agreement @choose="chooseAgreement" ref="agreementModel" :isSalesMan="true"></choose-agreement>
    </vxe-modal>
    <vxe-modal v-model="isShowChooseOrderTwo" width="1300" height="700" resize remember title="选择订单">
      <choose-order-new @choose="chooseOrderEventTwo" :currentRow="currentRow"
                        ref="refPaymentAboutOrderNew"></choose-order-new>
    </vxe-modal>
    <vxe-modal v-model="messageVisible" title="消息提示" width="600" height="350" @close="closeMessage" remember>
      <Message ref="messageModal" @close="closeMessage"></Message>
    </vxe-modal>
  </div>
</template>
<script>
import PlatformCorp from "@/components/common/PlatformCorp";
import SalesMan from "@/components/common/SalesMan";
import $api from "@/apiProvider";
import {showLoading, hideLoading} from "@/utils/util";
import Account from '@/components/modal/Account';
import ChooseOrderNew from "@/components/modal/ChooseOrderNew";
import ChooseAgreement from "@/components/order2.0/Agreement/ChooseAgreement";
import Message from "@/components/common/Message";
import XLSX from "xlsx";

export default {
  components: {PlatformCorp, SalesMan, Account, ChooseOrderNew, ChooseAgreement, Message},
  data() {
    return {
      tableData: [{
        no: 1,
        relOrdersNum: '',
        relContractNum: '',
      }],
      validRules: {
        ordersType: [{required: true, message: "请选择订单类型"}],
        sellerName: [{required: true, message: "请选择销售方"}],
        compName: [{required: true, message: "请选择所属公司"}],
        saleMan: [{required: true, message: "请选择业务员"}],
        settlementAmount: [{required: true, message: "请输入金额"}],
      },
      orderType: [],
      currentRow: {},
      isShowChooseAccount: false,
      isShowContract: false,
      isShowChooseOrderTwo: false,
      messageVisible: false,
    }
  },
  created() {
    this.getDict(59000, 'orderType');
  },
  methods: {
    clearRelOrdersNum(row) {
      row.relOrdersNum = null;
      row.choose = false;
    },
    async getDict(code, key) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code,
      });
      if (res.status === 1) {
        let arr = [];
        let data = res.data;
        data.map((i) => {
          arr.push({
            label: i.dictText,
            value: i.dictCode,
          });
        });
        this[key] = arr;
      } else {
        this.$XModal.message(res.message);
      }
    },
    async insertEvent(row) {
      let record = {
        no: this.$refs.xTable.data.length + 1,
        relOrdersNum: '',
        relContractNum: '',
      };
      let {row: newRow} = await this.$refs.xTable.insertAt(record, row);
      this.$refs.xTable.data.push(record);
    },
    removeEvent(row, i) {
      this.$refs.xTable.remove(row);
      this.$refs.xTable.data.splice(i, 1);
    },
    openOrderModal(row) {
      this.currentRow = row;
      this.isShowChooseOrderTwo = true;
      this.$refs.refPaymentAboutOrderNew.init();
    },
    chooseOrderEventTwo(row) {
      this.$set(this.currentRow, 'relOrdersNum', row.ordersNum);
      this.$set(this.currentRow, 'clientManage', row.clientManager);
      this.$set(this.currentRow, 'clientManageId', row.clientManagerId);
      this.$set(this.currentRow, 'saleMan', row.saleMan);
      this.$set(this.currentRow, 'saleManId', row.saleManId);
      this.$set(this.currentRow, 'compName', row.compName);
      this.$set(this.currentRow, 'platformCompanyId', row.platformCompanyId);
      this.$set(this.currentRow, 'choose', true);
      this.isShowChooseOrderTwo = false;
      this.$refs.xTable.clearValidate();
    },
    openChooseAccount(row) {
      this.currentRow = row;
      this.isShowChooseAccount = true;
      this.$refs.chooseAccount.init();
    },
    chooseAccountEvent(account, type) {
      if (type === 1) {
        this.currentRow.sellerName = account.compName;
        this.currentRow.sellerId = account.id;
        this.currentRow.sellerUserType = 2;
      } else {
        this.currentRow.sellerName = account.realName;
        this.currentRow.sellerId = account.id;
        this.currentRow.sellerUserType = 1;
      }
      this.isShowChooseAccount = false;
    },
    clearContractNum(row) {
      row.relContractNum = null;
      row.relContractId = null;
      row.relContractType = null;
      row.relContractCate = null;
    },
    openContract(row) {
      this.currentRow = row;
      this.isShowContract = true;
      this.$refs.agreementModel.init();
    },
    chooseAgreement(row, type) {
      if (type) {
        this.currentRow.relContractNum = row.contractNum;
        this.currentRow.relContractId = row.id;
        this.currentRow.relContractCate = 3;
        if (row.dataType === 1) {
          this.currentRow.relContractType = 2;
        } else {
          this.currentRow.relContractType = 1;
        }
      } else {
        this.currentRow.relContractNum = row.numb;
        this.currentRow.relContractId = row.id;
        this.currentRow.relContractCate = 2;
      }
      this.isShowContract = false;
    },
    setSaleMan(val, row) {
      if (val.clientManager) {
        this.$set(row, 'clientManage', val.clientManager);
        this.$set(row, 'clientManageId', val.clientManagerId);
      } else {
        this.$set(row, 'clientManage', null);
        this.$set(row, 'clientManageId', null);
      }
      this.clearValidate();
    },
    clearValidate() {
      this.$refs.xTable.clearValidate();
    },
    importEvent() {
      this.$refs.xTable.readFile({types: ["xls", "xlsx"]}).then((evnt) => {
        showLoading();
        const tableData = [];
        const files = evnt.target.files;
        const fileReader = new FileReader();
        fileReader.onload = (ev) => {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {type: "binary"});
          const csvData = XLSX.utils.sheet_to_csv(Object.values(workbook.Sheets)[0]);
          if (csvData.split("\n").length > 302) {
            hideLoading();
            this.$XModal.alert({
              message: "本次导入数据超过300条",
              status: "error",
            });
            return
          }
          // 解析数据
          csvData.split("\n").forEach((vRow, index) => {
            if (vRow && index > 0) {
              const vCols = vRow.split(",");

              let ordersType = null;
              let relContractCate = null;
              if (vCols[3]) {
                this.orderType.map(i => {
                  if (i.label === vCols[3]) {
                    ordersType = i.value;
                  }
                })
              }

              if (vCols[9]) {
                if (vCols[9].substring(0, 2) === 'NH') {
                  relContractCate = 2;
                } else {
                  relContractCate = 3;
                }
              }

              const item = {
                index: index,
                no: index,
                relOrdersNum: vCols[1],
                compName: vCols[2],
                ordersType: ordersType,
                ordersTitleAttached: vCols[4],
                sellerName: vCols[5],
                sellerRegisiterNum: vCols[6],
                settlementAmount: vCols[7],
                saleMan: vCols[8],
                relContractNum: vCols[9],
                relContractCate: relContractCate
              }
              tableData.push(item);
            }
            this.tableData = tableData;
          });
          setTimeout(() => {
            hideLoading();
          }, 1000);
        }
        fileReader.readAsBinaryString(files[0]);
      });
    },
    async validEvent() {
      let errMap = await this.$refs.xTable.validate().catch((errMap) => errMap);
      return errMap ? false : true;
    },
    closeMessage() {
      this.messageVisible = false;
    },
    async commit() {
      let self = this;
      let sts = await this.validEvent();
      if (!sts) {
        this.$XModal.message({status: "error", message: "校验不通过！"});
        return;
      }
      showLoading();
      let res = await $api.twoOrders.post("importAttachedOrder", this.tableData);
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("导入成功");
        this.$emit('afterSave');
      } else {
        let message = "";
        let message2 = "";
        let messageMap = new Map();
        if (res.data && res.data.length > 0) {
          let failArrayList = [];
          res.data.map((i) => {
            failArrayList.push(i.failArrayIndex);
            messageMap.set(i.failArrayIndex, i.failMsg);
            message = message + "第" + (i.failArrayIndex + 1) + "行，" + i.failMsg + "\n";
          });
          if (failArrayList.length > 0) {
            self.tableData.forEach((item, index) => {
              if (failArrayList.includes(index)) {
                message2 = message2 + "序号" + item.no + "，" + messageMap.get(index) + "\n";
              }
            });
          }
        }
        if (message === "") {
          if (res.message != null) {
            this.$XModal.alert({
              message: res.message,
              status: "error",
            });
          } else {
            this.$XModal.alert({
              message: "接口异常",
              status: "error",
            });
          }
        } else {
          message = message2;
          this.$refs.messageModal.setMessage(message);
          this.messageVisible = true;
        }
      }
    }
  }
}
</script>
<style>
.modal-footer {
  padding: 10px 0 0 0;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  position: absolute;
  bottom: 0;
}
</style>